<template>
	<div
		:id="`contact-person-${_uid}`"
		:class="[
			'c-block-list-contact-person-custom',
			'w-5col max-w-full mx-auto',
			{
				'>=768:w-6col': contactpersons && contactpersons.length <= 1,
				'c-block-list-contact-person-custom--wide >=768:w-12col':
					contactpersons &&
					contactpersons.length >= 2 &&
					!accordionLevel,
			},
		]"
	>
		<LongReadTarget
			v-if="title"
			:container-id="`contact-person-${_uid}`"
			:title="title"
		>
			<BaseH2 class="text-primary-button mb-sm" v-text="title" />
		</LongReadTarget>

		<SwiperWrap
			ref="sliderWrap"
			:move-by="1"
			:class="['relative ']"
			:items-wrapper-class-names="[
				'flex u-hide-scrollbar ',
				'c-block-list-contact-person-custom__swiper ',
				'snap snap-x snap-mandatory',
				'overflow-x-auto',

				{
					'c-block-list-contact-person-custom__swiper--in-accordion px-md':
						accordionLevel,
					'px-layout-margin': !accordionLevel,
				},
			]"
		>
			<template #items>
				<div
					v-if="contactpersons && contactpersons.length > 0"
					:class="[
						'flex <1024:gap-x-16 flex-grow justify-center',
						{ 'gap-x-layout-gutter': !accordionLevel },
						{ 'gap-x-8': accordionLevel },
					]"
				>
					<div
						v-for="(contactperson, index) in contactpersons"
						:key="index"
						:style="{
							minWidth: !accordionLevel ? '271px' : '247px',
						}"
						:class="[
							'bg-primary-button w-2col text-white rounded-lg p-md flex flex-grow  <1024:flex-col  ',
							{
								'flex-col':
									contactpersons.length > 2 ||
									(accordionLevel &&
										contactpersons.length >= 2),
							},
						]"
					>
						<UmbracoImageExt
							v-if="contactperson.image"
							:alt="contactperson.image.altText"
							:widths="[320, 480, 768, 480 * 2, 768 * 2]"
							:source-width="contactperson.image.width"
							:source-height="contactperson.image.height"
							:aspect-ratio="1"
							:source-url="
								contactperson.image.cropUrl ||
								contactperson.image.url
							"
							:class="[
								'rounded-full overflow-hidden <1024:mb-32 <1024:mx-auto c-block-list-contact-person-custom__image  ',
								{
									'mb-32 mx-auto':
										contactpersons.length > 2 ||
										(contactpersons.length >= 2 &&
											accordionLevel),
									'mr-40':
										(contactpersons.length <= 2 &&
											!accordionLevel) ||
										contactpersons.length < 2,
									'c-block-list-contact-person-custom__image--in-accordion':
										accordionLevel,
								},
							]"
							image-class-names="object-cover"
						/>

						<div v-else>
							<!--  first check if there is any images, if not check if it's siblings has any images and render a placeholder, otherwise render a empty template  -->
							<div
								v-if="
									contactpersons.some(
										(contactperson) => contactperson.image
									)
								"
								:class="[
									'rounded-full  bg-primary-button-hover <1024:mb-32 <1024:mx-auto c-block-list-contact-person-custom__image',
									{
										'mb-32  mx-auto':
											contactpersons.length > 2,
										'mr-40 ':
											contactpersons.length <= 2 &&
											!accordionLevel,
										'c-block-list-contact-person-custom__image--in-accordion':
											accordionLevel,
									},
								]"
							></div>
							<template v-else> </template>
						</div>
						<div class="flex flex-col break-words >=768:w-7/12">
							<span class="uppercase text-h8">{{
								contactperson.title
							}}</span>
							<BaseH3
								class="mt-8 mb-16 c-overide-accordion-color"
								>{{ contactperson.name }}</BaseH3
							>
							<a
								v-if="contactperson.phone"
								:href="`tel:${contactperson.phone}`"
								class="
									mt-16
									flex
									items-center
									w-fit
									hover:underline
								"
							>
								<SvgPhoneIcon class="w-12 h-12 mr-12" />
								<span>{{ contactperson.phone }}</span>
							</a>
							<a
								v-if="contactperson.mobile"
								:href="`tel:${contactperson.mobile}`"
								class="
									mt-16
									flex
									items-center
									w-fit
									hover:underline
								"
							>
								<SvgMobileIcon class="w-12 h-12 mr-12" />
								<span>{{ contactperson.mobile }}</span>
							</a>
							<a
								v-if="contactperson.email"
								:href="`mailto:${contactperson.email}`"
								class="
									mt-16
									flex
									items-baseline
									w-fit
									hover:underline
								"
							>
								<span>
									<SvgMailIcon class="w-12 h-12 mr-12" />
								</span>
								<span class="break-all">{{
									contactperson.email
								}}</span>
							</a>
							<NuxtLinkExt
								v-if="
									contactperson.website &&
									contactperson.website[0]
								"
								class="block w-fit"
								:to="contactperson.website[0].url"
								:target="contactperson.website[0].target"
							>
								<BaseButton
									tag="div"
									class="w-fit mt-md"
									outline="white-1"
								>
									<template #default>
										{{ titles.buttonTitle }}</template
									>
								</BaseButton>
							</NuxtLinkExt>
						</div>
					</div>
				</div>
			</template>
		</SwiperWrap>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import SvgPhoneIcon from '~/assets/svgs/phone-icon.svg?inline';
import SvgMobileIcon from '~/assets/svgs/mobile-icon.svg?inline';
import SvgMailIcon from '~/assets/svgs/mail-icon.svg?inline';
import SwiperWrap from '~/citi-baseline/components/SwiperWrap.vue';

export default {
	name: 'BlockListContactPersonCustom',
	components: {
		UmbracoImageExt,
		LongReadTarget,
		SvgPhoneIcon,
		SvgMailIcon,
		SvgMobileIcon,
		SwiperWrap,
	},

	inject: {
		accordionLevel: {
			default: 0,
		},
	},
	inheritAttrs: false,
	props: {
		title: String,
		titles: Object,
		contactpersons: Array,
	},
};
</script>

<style lang="postcss">
.c-block-list-contact-person-custom__image--in-accordion {
	width: 164px !important;
	height: 164px !important;
}
.c-block-list-contact-person-custom__image {
	width: 192px;
	height: 192px;
}

.c-block-list-contact-person-custom .text-white,
.c-block-list-contact-person-custom .text-white * {
	color: #ffffff !important;
}

.c-accordion-layout .c-accordion-panel .c-overide-accordion-color {
	color: #ffffff !important;
}

.c-block-list-contact-person-custom__swiper {
	width: calc(
		var(--theme-layout-margin, var(--theme-layout-margin--sm)) * 2 + 100%
	);
	margin-left: calc(
		0px - var(--theme-layout-margin, var(--theme-layout-margin--sm))
	);
}
.c-block-list-contact-person-custom__swiper--in-accordion {
	width: calc(var(--theme-spacing-md, var(--theme-spacing-md)) * 2 + 100%);
	margin-left: calc(0px - var(--theme-spacing-md, var(--theme-spacing-md)));
}
</style>
